
import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { grey } from "@mui/material/colors";
import { spacing } from "../../constants/designTokens";

export const StyledPageHeader = styled(Box)(({ theme }) => ({
  width: "100%",
  minHeight: "4.5rem",
  padding: `${spacing.md}px ${spacing.md}px ${spacing.sm}px`,
  margin: 0,
  borderBottom: `1px solid ${grey[400]}`,
  background: "white",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "0.75rem",
  flexWrap: "wrap",
  [theme.breakpoints.up("md")]: {
    padding: `${spacing.lg}px ${spacing.lg}px ${spacing.md}px`,
  },
}));
